
import { defineComponent, PropType } from 'vue';
import FilterMenuUtils from './filter-menu.utils';
import TpxButton from '../../atoms/button/button.vue';
import TpxFilterGroup from './filter-group.vue';
import TpxForm from '../form/form.vue';
import './filter-menu.scss';

/**
  * Filter menu
  * 
  * @example
  * <code>import TpxFilterMenu from '@manifesto-tech/tpximpact-design-system/components/molecules/filter/filter-menu.vue'</code>
  */
export default defineComponent({
  name: 'TpxFilterMenu',

  components: {
    TpxButton,
    TpxFilterGroup,
    TpxForm,
  },

  emits: [
    'change',
  ],

  methods: {
    /**
     * Close the filter menu
     * @see FilterMenuUtils.close()
     */
    close() {
      this.filterMenuUtils.close();
    },

    /**
     * Handle change of checkboxes within the filter menu
     */
    onChange() {
      //this.activeFilterCount = 0;
      //this.filterGroupsData?.forEach(filterGroup => this.activeFilterCount += filterGroup.checkboxes?.filter(c => c.isChecked).length);
      this.$emit('change');
    },

    /**
     * Open the filter menu
     * @see FilterMenuUtils.open()
     */
    open() {
      this.filterMenuUtils.open();
    },

    /**
     * Close filter groups once anywhere else on the page is clicked
     */
    closeAllTheFilterGroups() {
      const formBackdrop = this.$refs.formBackdrop;
      const filtergroups = this.$refs.filtergroup;

      if (formBackdrop != null && filtergroups != null) {
        filtergroups.forEach((afiltergroup) => {
          const filtergroupContentDiv = afiltergroup.$refs.content;
          const filtergroupIcon = afiltergroup.$refs.icon;
          if (filtergroupContentDiv != null) { filtergroupContentDiv.classList.remove("is-open"); }
          if (filtergroupIcon != null) { filtergroupIcon.classList.remove("is-open"); }
        })
        formBackdrop.classList.remove("is-open");
      }
    },


    /**
     * Reset filters
     */
    resetFilters() {
      this.activeFilterCount = 0;
      this.filterGroupsData?.forEach(filterGroup => {
        filterGroup.checkboxes.forEach(checkbox => checkbox.isChecked = false);
      });
      this.$emit('change');
      const urlWithoutSearchParams = window.location.href.split("?")[0];
      window.location.replace(urlWithoutSearchParams);
    },
  },

  data() {
    return {
      activeFilterCount: 0,
      filterGroupsData: this.filterGroups,
    }
  },

  mounted() {
    this.filterMenuUtils = new FilterMenuUtils(this.$refs.root as HTMLElement);

    /** 
     * If url has search parameters, those filters are applied so update activeFilterCount here
    */
    const searchParams = new URLSearchParams(window.location.search);
    const activeSectorFilters = searchParams.getAll('Sector');
    const activeServiceFilters = searchParams.getAll('Service');
    const activeTopicFilters = searchParams.getAll('Topic');
    const allActiveFilters = [...activeSectorFilters, ...activeServiceFilters, ...activeTopicFilters];
    this.activeFilterCount = allActiveFilters.length;
  },

  props: {
    /**
     * Filter groups to be displayed within this menu
     */
    filterGroups: {
      type: Array as PropType<Array<typeof TpxFilterGroup>>,
    },
  },
});
